"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateCoupon = void 0;
const com = require("../../com/tmpls");
const modalCom = require("@ivanlog/gs-com-modal_dialogs");
const StatePaged_1 = require("../abstracts/StatePaged");
const models_1 = require("../../api/admin/classes/models");
const gs_1 = require("@ivanlog/gs");
const AccessTypeEnum_1 = require("../../enums/AccessTypeEnum");
const StateCoupons_1 = require("./StateCoupons");
class StateCoupon extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageCoupon, "Coupon", true);
        this._canEdit = false;
        this.page.ctrls.btnSave.onclick = () => this._trySave();
        this.page.ctrls.btnDelete.hide();
        this.page.ctrls.btnDelete.onclick = () => this._tryDeleteOrRestore();
    }
    start(args) {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            this._coupon = undefined;
            if (args) {
                if (args instanceof models_1.CouponDO)
                    this._coupon = args;
                else if (args.id) {
                    const id = parseInt(args.id, 10);
                    if (!Number.isNaN(id)) {
                        const list = yield this.lockgui(this.app.api.admin.coupons.list(true));
                        if (!list)
                            return gs_1.StateRunResultEnum.Failed;
                        this._coupon = list.find((c) => c.id === id);
                        if (!this._coupon)
                            return gs_1.StateRunResultEnum.Failed;
                    }
                }
            }
            this._canEdit = this.app.auth.hasAccess(AccessTypeEnum_1.AccessTypeEnum.RateControl);
            if (!this._canEdit) {
                this.page.ctrls.btnSave.hide();
                this.page.ctrls.btnDelete.hide();
                this.page.ctrls.form.addClass("no-active");
            }
            else {
                this.page.ctrls.btnSave.show();
                this.page.ctrls.form.removeClass("no-active");
                if (this._coupon) {
                    this.page.ctrls.btnDelete.show();
                }
                else {
                    this.page.ctrls.btnDelete.hide();
                }
            }
            yield this._fill();
            return _super.start.call(this);
        });
    }
    _fill() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
            const ctrl = this.page.ctrls;
            const isNew = !this._coupon;
            yield ctrl.form.fillFormData({
                code: (_b = (_a = this._coupon) === null || _a === void 0 ? void 0 : _a.code) !== null && _b !== void 0 ? _b : "",
                percent: Number.isFinite((_c = this._coupon) === null || _c === void 0 ? void 0 : _c.percent) &&
                    ((_d = this._coupon) === null || _d === void 0 ? void 0 : _d.percent) !== undefined
                    ? this._coupon.percent.toString()
                    : "",
                validFrom: ((_e = this._coupon) === null || _e === void 0 ? void 0 : _e.validFrom)
                    ? this._formatInputDate(this._coupon.validFrom)
                    : "",
                validTo: ((_f = this._coupon) === null || _f === void 0 ? void 0 : _f.validTo)
                    ? this._formatInputDate(this._coupon.validTo)
                    : "",
                maxUsages: Number.isInteger((_g = this._coupon) === null || _g === void 0 ? void 0 : _g.maxUsages) &&
                    ((_h = this._coupon) === null || _h === void 0 ? void 0 : _h.maxUsages) !== undefined
                    ? this._coupon.maxUsages.toString()
                    : "",
            }, true);
            const isActive = isNew ? true : Boolean((_j = this._coupon) === null || _j === void 0 ? void 0 : _j.isActive);
            this._setIsActiveControl(isActive);
            ctrl.chIsActive.el.disabled = !this._canEdit;
            if (isNew) {
                ctrl.blockUsedCount.hide();
                ctrl.blockCreated.hide();
                ctrl.blockUpdated.hide();
                ctrl.btnDelete.hide();
            }
            else {
                ctrl.blockUsedCount.show();
                ctrl.blockCreated.show();
                ctrl.blockUpdated.show();
                ctrl.pUsedCount.text = `${(_l = (_k = this._coupon) === null || _k === void 0 ? void 0 : _k.usedCount) !== null && _l !== void 0 ? _l : 0}`;
                ctrl.pCreated.text = this._formatReadableDate((_m = this._coupon) === null || _m === void 0 ? void 0 : _m.created);
                ctrl.pUpdated.text = this._formatReadableDate((_o = this._coupon) === null || _o === void 0 ? void 0 : _o.updated);
            }
            this._updateDeleteButton();
            this.setLabel(this._coupon
                ? `${this.title} #${this._coupon.id} ${this._coupon.code}${this._coupon.isActive ? "" : " (inactive)"}`
                : "New coupon");
        });
    }
    _trySave() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!this._canEdit)
                return;
            const data = yield this.page.ctrls.form.getFormData();
            if (!data)
                return;
            const percent = parseFloat(data.percent);
            if (Number.isNaN(percent) || percent < 0 || percent > 100) {
                yield new modalCom.DialogOk("Percent must be between 0 and 100").show();
                return;
            }
            const maxUsages = data.maxUsages ? parseInt(data.maxUsages, 10) : undefined;
            if (data.maxUsages && (Number.isNaN(maxUsages) || maxUsages < 0)) {
                yield new modalCom.DialogOk("Max usages must be a positive integer").show();
                return;
            }
            const validFrom = data.validFrom ? new Date(data.validFrom) : undefined;
            const validTo = data.validTo ? new Date(data.validTo) : undefined;
            if (validFrom && validTo && validTo.getTime() < validFrom.getTime()) {
                yield new modalCom.DialogOk("Valid to must be after valid from").show();
                return;
            }
            const payload = this._coupon ? new models_1.CouponDO(this._coupon) : {};
            payload.code = ((_a = data.code) !== null && _a !== void 0 ? _a : "").trim();
            payload.percent = percent;
            payload.validFrom = validFrom;
            payload.validTo = validTo;
            payload.maxUsages = maxUsages !== null && maxUsages !== void 0 ? maxUsages : null;
            payload.isActive = this.page.ctrls.chIsActive.el.checked;
            payload.usedCount = this._coupon ? this._coupon.usedCount : 0;
            if (!payload.code) {
                yield new modalCom.DialogOk("Coupon code is required").show();
                return;
            }
            delete payload.created;
            delete payload.updated;
            if (this._coupon) {
                const updated = yield this.lockgui(this.app.api.admin.coupons.update(payload));
                if (!updated)
                    return;
                this._coupon = updated;
                yield new modalCom.DialogOk("Coupon updated").show();
                yield this._fill();
            }
            else {
                const created = yield this.lockgui(this.app.api.admin.coupons.create(payload));
                if (!created)
                    return;
                yield new modalCom.DialogOk("Coupon created").show();
                yield gs_1.StateGS.Run(StateCoupons_1.StateCoupons);
            }
        });
    }
    _setIsActiveControl(value) {
        this.page.ctrls.chIsActive.el.checked = value;
        this.page.ctrls.chIsActive.el.value = value ? "true" : "false";
    }
    _updateDeleteButton() {
        var _a;
        const btn = this.page.ctrls.btnDelete;
        if (!btn)
            return;
        if (!this._canEdit || !((_a = this._coupon) === null || _a === void 0 ? void 0 : _a.id)) {
            btn.hide();
            return;
        }
        btn.el.title = this._coupon.isActive
            ? "Deactivate coupon"
            : "Restore coupon";
        btn.show();
    }
    _tryDeleteOrRestore() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!this._canEdit || !((_a = this._coupon) === null || _a === void 0 ? void 0 : _a.id))
                return;
            if (this._coupon.isActive) {
                const response = yield this.lockgui(this.app.api.admin.coupons.delete(this._coupon.id));
                if (response === undefined || response === null)
                    return;
                yield this._refreshCouponFromApi();
                if (this._coupon)
                    this._coupon.isActive = false;
                yield new modalCom.DialogOk("Coupon deactivated").show();
            }
            else {
                const restored = yield this.lockgui(this.app.api.admin.coupons.restore(this._coupon.id));
                if (!restored)
                    return;
                this._coupon = restored;
                yield new modalCom.DialogOk("Coupon restored").show();
            }
            yield this._fill();
        });
    }
    _refreshCouponFromApi() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!((_a = this._coupon) === null || _a === void 0 ? void 0 : _a.id))
                return;
            const list = yield this.lockgui(this.app.api.admin.coupons.list(true));
            if (!list)
                return;
            const updated = list.find((coupon) => coupon.id === this._coupon.id);
            if (updated)
                this._coupon = updated;
        });
    }
    _formatInputDate(value) {
        const year = value.getFullYear();
        const month = this._pad(value.getMonth() + 1);
        const day = this._pad(value.getDate());
        const hours = this._pad(value.getHours());
        const minutes = this._pad(value.getMinutes());
        return `${year}-${month}-${day}T${hours}:${minutes}`;
    }
    _formatReadableDate(value) {
        if (!value)
            return "—";
        try {
            return value.toLocaleString();
        }
        catch (e) {
            return value.toString();
        }
    }
    _pad(num) {
        return num < 10 ? `0${num}` : num.toString();
    }
}
exports.StateCoupon = StateCoupon;
StateCoupon.StateName = "coupon";
//# sourceMappingURL=StateCoupon.js.map